import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import SearchTable from "../../../components/SearchTable";
import EmptyData from "../../../components/EmptyData";
import TableFilter from "../../../components/TableFilter";
import { categoryPublicContext } from "../../../context/PublicContext/CategoryPublicContext/CategoryPublicContext";
import { convertRoleToPath } from "../../../utils/enum";
import { hostname } from "../../../services/configServices/config";

const CategoriesPublic = () => {
  const auth = useSelector((state) => state.auth);

  const { category } = useParams();

  const { categories, filter, setFilter, sort, setSort, handleGetCategories } =
    useContext(categoryPublicContext);

  useEffect(() => {
    handleGetCategories();
  }, [sort, category]);

  return (
    <>
      <SiteTitle title="دسته بندی ها" />

      <TableFilter setSort={setSort} sort={sort} />

      <div className="card h-100 p-0 radius-12">
        <SearchTable
          filter={filter}
          setFilter={setFilter}
          onSearch={handleGetCategories}
        />
        <div className="card-body p-24">
          {isEmpty(categories) ? (
            <EmptyData />
          ) : (
            <div className="row gy-4">
              {categories?.map((_item) => (
                <div
                  className="col-12 col-md-6 col-xl-4 col-xxl-3"
                  key={_item._id}
                >
                  <Link
                    to={`${
                      auth.role ? `/${convertRoleToPath(auth.role)}` : ""
                    }/${_item?.existSubCategories ? "category" : "product"}/${
                      _item._id
                    }/category`}
                    className="card h-100 radius-12 p-0 overflow-hidden position-relative"
                  >
                    <div className="card-body p-0 gradient-overlay top-0 start-0">
                      <img
                        src={
                          _item.avatar
                            ? `${hostname}${_item.avatar}`
                            : "/assets/images/empty-image.png"
                        }
                        alt=""
                        className="w-100 h-100"
                      />

                      <div className="position-absolute start-0 top-0 p-24 z-1 text-center">
                        <h5 className="card-title text-white text-lg mb-6  text-truncate">
                          {_item.title}
                        </h5>
                        <p className="card-text text-white text-pre-wrap">
                          {_item.description}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CategoriesPublic;
